export const getJobShareUrl = (jobId) => {
  const apiBase =
    process.env.REACT_APP_BASE_URL ||
    `${window.location.origin.replace(/\/$/, "")}/api/v1`;
  return `${apiBase.replace(/\/$/, "")}/share/job/${jobId}`;
};

export const getJobPageUrl = (jobId) => {
  const siteUrl = process.env.REACT_APP_SITE_URL || window.location.origin;
  return `${siteUrl.replace(/\/$/, "")}/job-description/${jobId}`;
};

export const getProfilePageUrl = (userId) => {
  const siteUrl = process.env.REACT_APP_SITE_URL || window.location.origin;
  return `${siteUrl.replace(/\/$/, "")}/Jobseeker/${userId}`;
};
